import { ParentContext } from 'global/cnr/contexts/ParentContext';
import AppForm from 'global/components/forms/appForms/AppForm';
import ItemMenuSquares from 'global/wrappers/ItemMenuSquares ';
import Wrapper, { wrapperTypes } from 'global/wrappers/Wrapper';
import WrapperVertCols from 'global/wrappers/WrapperVertCols';
import React, { useContext, useState } from 'react'
import AppNotificationsManager, { appNotificationTypes } from './AppNotificationsManager';
import { useNotifications } from 'global/cnr/contexts/useHelpers/useNotifications';
import { useSettings } from 'global/cnr/contexts/useHelpers/useSettings';
import { useAppUserAccess } from 'global/cnr/contexts/useHelpers/useAppUserAccess';
import DropdownOptionsMenu from 'global/components/forms/elements/DropdownOptionsMenu';
import { openExternal } from 'global/viewSettings/helpers/settingsLinks';
import { iconColorTypes } from 'global/enums/settingsIconTypes';

const _settings = {
  globalScheduledNotifications: 'globalScheduledNotifications',
  appNotifications: 'appNotifications',
}

const _app = {
  notificationsManager: 'notificationsManager',
}

const _notificationDashboardTypes = {
  ..._settings,
  ..._app,
}

export const NotificationsDashboard = () => {

  const appUserAccess = useAppUserAccess()
  const { isAdminOrSuper } = appUserAccess ?? {}

  const parentContext = useContext(ParentContext);
  const { states, handlers, fns, fn_cls } = parentContext ?? {}
  const { baseSettings_state, currentSettings_state, paps_state } = states
  const { pathViews } = paps_state ?? {}

  const { groupItems: groupItems_scheduledNotifications } = _.get(baseSettings_state, 'baseSettings.global.scheduledNotifications', {});
  const { groupItems: groupItems_appNotifications } = _.get(baseSettings_state, 'baseSettings.global.appNotifications', {});

  const { scheduledNotifications } = _.get(currentSettings_state, 'gvviSettings.aps_global', {});
  const { appNotifications } = _.get(currentSettings_state, 'gvviSettings.aps_global', {});

  const [selectedListType, setSelectedListType] = useState(_notificationDashboardTypes.globalScheduledNotifications)
  const [data_scheduledNotifications, setData_scheduledNotifications] = useState(scheduledNotifications)
  const [data_appNotifications, setData_appNotifications] = useState(appNotifications)
  const [updating, setUpdating] = useState()

  const { updateScheduledNotifications } = useNotifications()
  const settings_fns = useSettings()

  const handleSelectedListType = (sl) => setSelectedListType(sl)
  const handleAmmend_scheduleNotifications = (d) => setData_scheduledNotifications(d)
  const handleAmmend_appNotifications = (d) => setData_appNotifications(d)

  const handleOpenDb = () => openExternal.db({}, false, ['notificationSchedules'])

  const handleSave_scheduledNotifications = () => {
    setUpdating(true)
    const cb = (res) => {
      setUpdating()
    }
    updateScheduledNotifications(data_scheduledNotifications, pathViews, cb)
  }

  const handleSave_appNotifications = () => {
    setUpdating(true)
    const cb = (res) => {
      setUpdating()
    }
    const _dataToUpdate = {
      appNotifications: { ...data_appNotifications }
    }
    settings_fns.updateGlobalFromSidebar(pathViews, _dataToUpdate, appUserAccess, cb)
  }

  const hc = (mt) => {
    handleSelectedListType(mt.key)
  }

  const squareText = (key) => {
    switch (key) {
      default:
        return _.startCase(key)
    }
  }

  const squareIcon = (key) => {
    switch (key) {
      default:
        return { icon: 'settings', iconColor: 'grey' }
    }
  }

  const ims_global = () => {
    const mis = _.mapValues(_.keyBy(_settings), (v) => ({
      key: v,
      caption: squareText(v),
      ...squareIcon(v),
      selected: v === selectedListType,
    }));
    return <ItemMenuSquares caption={'Settings'} menuItems={mis} onClick={hc} icon={'settings'} />
  }

  const ims_app = () => {
    const mis = _.mapValues(_.keyBy(_app), (v) => ({
      key: v,
      caption: squareText(v),
      ...squareIcon(v),
      selected: v === selectedListType,
    }));
    return <ItemMenuSquares caption={'Notifications'} menuItems={mis} onClick={hc} icon={'list'} />
  }

  const content_left = () => <React.Fragment>
    {ims_global()}
    {ims_app()}
  </React.Fragment>

  const wrapper = (content) => <Wrapper
    header={_.startCase(selectedListType)}
    content={content}
    wrapperType={wrapperTypes.padded}
  ></Wrapper>

  const footer_options = () => {
    const btns_dd = []
    if (isAdminOrSuper) {
      btns_dd.push({ oc: handleOpenDb, icon: 'external alternate', color: iconColorTypes.external, caption: 'Open Notification Schedules DB', fl: true })
    }

    return <div className={'header-flex'}>
      <div>
        <DropdownOptionsMenu menuButtons={btns_dd} caption={'Options'} icon={'unordered list'} color={'blue'} direction={'right'} upward={true} />
      </div>
    </div>
  }

  const content_right = () => {
    switch (selectedListType) {
      case _notificationDashboardTypes.globalScheduledNotifications:
        return wrapper(<AppForm
          key={`app-form-${selectedListType}`}
          dataPropType={selectedListType}
          appFormItems={groupItems_scheduledNotifications}
          data_parent={data_scheduledNotifications}
          handleUpdateParentData={handleAmmend_scheduleNotifications}
          handleSave={handleSave_scheduledNotifications}
          handleSaveCaption={`Update ${_.startCase(selectedListType)}`}
          defaultOptions={{}}
        />)
      case _notificationDashboardTypes.appNotifications:
        return wrapper(<AppForm
          key={`app-form-${selectedListType}`}
          dataPropType={selectedListType}
          appFormItems={groupItems_appNotifications}
          data_parent={data_appNotifications}
          handleUpdateParentData={handleAmmend_appNotifications}
          handleSave={handleSave_appNotifications}
          handleSaveCaption={`Update ${_.startCase(selectedListType)}`}
          defaultOptions={{}}
        />)
      case _notificationDashboardTypes.notificationsManager:
        return wrapper(<AppNotificationsManager forSettings={true} appNotificationType={appNotificationTypes.notificationsManager} />)
      default:
        return wrapper(<div>{selectedListType}</div>)
    }
  }

  const wrapper_left = () => <Wrapper
    header={'Notification Options'}
    content={content_left()}
    footer={footer_options()}
    updating={updating}
    wrapperType={wrapperTypes.padded}
  />

  return <WrapperVertCols mvc={'1-3'}  >
    {wrapper_left()}
    {content_right()}
  </WrapperVertCols>

}
